import { useQuery } from 'react-query';
import { tableFilterQueryMaker } from '@shared/modules/next-table/utils/query-maker';
import { CustomsDeclarationsService } from '../../services';

type Filters = { id: string | number; value: any }[];

export const useCustomsDeclarationsCounts = (filters: Filters, enabled: boolean) => {
  const filterQuery = tableFilterQueryMaker(filters);

  return useQuery(['customs', 'declarations', 'counts', filterQuery], () => CustomsDeclarationsService.getCounts(filterQuery), { enabled });
};
